"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const template_parser_1 = require("@osmosys/template-parser");
const hooks_1 = require("../hooks");
const react_use_1 = require("react-use");
const index_1 = require("./RefreshContentModal/index");
// import { clearBlocks, emailTemplateBlocksHave } from '@osmosys/template-parser';
// import { useDebounce, useToggle } from 'react-use';
// import { EmailTemplateBlock } from '@osmosys/models';
// import { useEmailCanvasCanvas } from '../hooks';
exports.EmailCanvasRefreshContentButton = () => {
    const { data: { draftEmail, contentRefreshModalIsOpen }, update, } = hooks_1.useEmailCanvasCanvas('state');
    const blocks = draftEmail.blocks || [];
    const [canRefresh, toggleCanRefresh] = react_use_1.useToggle(false);
    const prevContentRefreshModalIsOpen = react_use_1.usePrevious(contentRefreshModalIsOpen);
    const [spinStateHasFinishedFn, cancel, resetSpinState] = react_use_1.useTimeout(2000);
    const spinStateHasFinished = spinStateHasFinishedFn();
    react_use_1.useUnmount(() => {
        cancel();
    });
    react_2.useEffect(() => {
        if (contentRefreshModalIsOpen && !prevContentRefreshModalIsOpen) {
            resetSpinState();
        }
    }, [prevContentRefreshModalIsOpen, contentRefreshModalIsOpen]);
    const testIfCanRefresh = (testingBlocks) => {
        const newCanRefresh = template_parser_1.emailTemplateBlocksHave(testingBlocks, 'refreshable', true, true);
        if (newCanRefresh !== canRefresh) {
            toggleCanRefresh(newCanRefresh);
        }
    };
    react_2.useEffect(() => {
        testIfCanRefresh(blocks);
    }, []);
    react_use_1.useDebounce(() => {
        testIfCanRefresh(blocks);
    }, 200, [...blocks]);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasRefreshContentButton", osysIcon: "reload", iconSpin: contentRefreshModalIsOpen && !spinStateHasFinished, onClick: () => {
                update({
                    contentRefreshModalIsOpen: true,
                });
                // if (!canClear) {
                //   alert('Sorry, but there are no unlocked blocks to clear.');
                //   return;
                // }
                // const confirmation = window.confirm('Are you sure?');
                // if (confirmation) {
                //   update({
                //     draftEmail: {
                //       ...draftEmail,
                //       blocks: clearBlocks(blocks),
                //     },
                //   });
                // }
            }, tooltip: canRefresh ? 'Refresh content' : 'No content to refresh', disabled: contentRefreshModalIsOpen || !canRefresh }),
        react_2.default.createElement(index_1.EmailCanvasRefreshContentModal, null)));
};
//# sourceMappingURL=RefreshContentButton.js.map